import type { SessionWorktreeBinding } from '../session-worktree-binding.js';
import { tryBindingFromIsolatedDirectory } from './try-binding-from-isolated-directory.js';

export async function tryBindingFromSessionDirectory(sessionDir: string): Promise<SessionWorktreeBinding | null> {
  const binding = await tryBindingFromIsolatedDirectory(sessionDir);
  if (!binding) return null;
  return {
    sessionParentPath: binding.parentPath,
    repoCheckoutPaths: binding.repoCheckoutPaths,
  };
}

export { tryBindingFromIsolatedDirectory };
